import AppIconButton from '@nxsys/components/AppIconButton';
import { IconDelete } from '@nxsys/components/AppIconSvg';
import AppTagStatus from '@nxsys/components/AppTagStatus';
import { DeleteStatutoryParams } from '@nxsys/store/slices/statutory/types';
import { Icons } from '@nxsys/types/icons';
import { formatStatus } from '@nxsys/utils';
import { STATUTORY_PAYMENT_OPTION } from '@nxsys/constants/statutory';
import { Tooltip } from 'antd';
import { ColumnsType } from 'antd/es/table';
import moment from 'moment';

export const getColumns = ({
  handleDeleteStatutory,
  messages,
  handleViewDetail,
}: {
  handleDeleteStatutory: (params: DeleteStatutoryParams) => void;
  messages: any;
  handleViewDetail: (type: string, id: string) => void;
}): ColumnsType<any> => {
  return [
    {
      key: 'actions',
      title: messages['statutory.column.actions'],
      fixed: 'left',
      align: 'left',
      render: (record) => (
        <ul className="table-actions flex items-center justify-center">
          <li onClick={() => handleViewDetail(record?.type, record?.id)}>
            <Tooltip title="Edit">
              <span><Icons.IconEdit /></span>
            </Tooltip>
          </li>
          <li>
            <AppIconButton
              title={messages['statutory.column.delete']}
              icon={<IconDelete />}
              onClick={() =>
                handleDeleteStatutory([
                  {
                    id: record?.id,
                    type: record?.type,
                  },
                ])
              }
            />
          </li>
        </ul>
      ),
      width: 100,
    },
    {
      key: 'Diary Status',
      title: messages['statutory.column.diaryStatus'],
      align: 'center',
      render: (record) => {
        const status = record?.status;
        return (
          <span className={`${formatStatus(status)}`}>
            <AppTagStatus className={`tag-popup ${formatStatus(status)}`}>
              {formatStatus(status)}
            </AppTagStatus>
          </span>
        );
      },
      width: 150,
    },
    {
      key: 'Leave Type',
      title: messages['statutory.column.leaveType'],
      dataIndex: 'type',
      align: 'center',
      render: (record) =>
        STATUTORY_PAYMENT_OPTION.find((o) => o.value === record)?.label ?? '',
      width: 200,
    },
    {
      key: 'id',
      title: messages['statutory.column.systemId'],
      dataIndex: 'id',
      width: 150,
    },
    {
      key: 'Forename',
      title: messages['statutory.column.forename'],
      dataIndex: 'forename',
      width: 150,
    },
    {
      key: 'Surname',
      title: messages['statutory.column.surname'],
      dataIndex: 'surname',
      width: 150,
    },
    {
      key: 'Agency Ref',
      title: messages['statutory.column.agencyRef'],
      render: (record) =>
        `${record?.agencyPrefix || '___'}/${
          record?.agencyRef || record?.id || '_'
        }`,
      width: 200,
    },
    {
      key: 'Primary Agency',
      title: messages['statutory.column.primaryAgency'],
      render: (record) => record?.name,
      width: 250,
    },
    {
      key: 'Payment Company',
      title: messages['statutory.column.paymentCompany'],
      dataIndex: 'companyName',
      width: 250,
    },
    {
      key: 'Date Created',
      title: messages['statutory.column.dateCreated'],
      dataIndex: 'createdAt',
      align: 'right',
      render: (value) => (
        <span>
          {value ? moment(value).tz('Europe/London').format('DD/MM/YYYY') : ''}
        </span>
      ),
      width: 150,
    },
    {
      key: 'error',
      title: `${messages['statutory.column.error']} / ${messages['statutory.column.warning']}`,
      render: (value) => <span>{value?.error || value?.warning}</span>,
    },
  ];
};
